import { Button, Form, Grid, Input, Modal, Table } from 'semantic-ui-react'
import OrderItemDetailTwo from '../OrderItemDetail/OrderItemDetailTwo'
import MickeyDropdown from '../MickeyDropdown/MickeyDropdown'
import GetProductVariant from '../ProductVariant.js/GetProductVariant'
import { useEffect, useState } from 'react'
import env from '../../env'
import { formatTotalPrice } from '../../lib/utils/utils'
import useAxios from '../../lib/auth/useAxios'
import { toast } from 'react-toastify'
import ConfirmationModal from '../ConfirmationModal'
import { Plus, TrashSimple, X } from 'phosphor-react'
import MickeyTable from '../MickeyTable/MickeyTable'
import './SalesOrders.css'
import { useSelector } from 'react-redux'
import SemanticDatepicker from 'react-semantic-ui-datepickers'

function AddSalesOrder(props) {
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const axios = useAxios()
  const {
    buyer,
    orderItems,
    order,
    salesOrderId,
    openSalesOrderModal,
    setOpenSalesOrderModal,
    buyer_id,
    salesOrder,
    setSalesOrder,
    reload,
    setReload,
    update,
    setUpdate,
    hideBusiness,
    openAddSalesOrderModal,
    setOpenAddSalesOrderModal,
  } = props
  let lineItems_ = []
  if (orderItems) {
    lineItems_ = orderItems?.map((orderItem) => {
      return {
        product_variant: orderItem?.product_variant,
        quantity: orderItem?.quantity,
        buyer_unit_id: orderItem?.buyer_unit?.id,
        price: orderItem?.price,
        oi_id: orderItem?.id,
      }
    })
  }
  const [buyerId, setBuyerId] = useState(buyer_id)
  const [salesOrderNumber, setSalesOrderNumber] = useState()
  const [openProductVariantModal, setOpenProductVariantModal] = useState(false)
  const [openArchiveLineItemModal, setOpenArchiveLineItemModal] =
    useState(false)
  const [archiveLineItems, setArchiveLineItems] = useState([])
  const [productVariant, setProductVariant] = useState()
  const [lineItems, setLineItems] = useState(lineItems_)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState({})
  const [dropItemIdx, setDropItemIdx] = useState()
  const [dropItemId, setDropItemId] = useState()
  const [locationId, setLocationId] = useState()
  const [shipVia, setShipVia] = useState('')
  const [paymentTerms, setPaymentTerms] = useState('')
  const [fob, setFob] = useState('')
  const [expectedShipDate, setExpectedShipDate] = useState('')
  const [requisitioner, setRequisitioner] = useState('')
  const [shippingCost, setShippingCost] = useState(0)
  const [salesTax, setSalesTax] = useState(0)

  useEffect(() => {
    const getSalesOrder = async () => {
      let res = await axios.get(`/main/admin-sales-order/${salesOrderId}/`)
      setSalesOrder(res.data)
    }
    if (salesOrderId) {
      getSalesOrder()
    }
  }, [salesOrderId])

  useEffect(() => {
    if (productVariant?.id) {
      setLineItems([
        ...lineItems,
        {
          product_variant: productVariant,
          quantity: 0,
          uom_id: null,
          price: null,
        },
      ])
    }
  }, [productVariant])

  useEffect(() => {
    setBuyerId(buyer?.id)
  }, [buyer])

  // Auto-populate buyer and location from order when modal opens
  useEffect(() => {
    if (order && !salesOrder?.id && !buyerId) {
      // Set buyer from order
      if (order.buyer?.id) {
        setBuyerId(order.buyer.id)
      }
      // Set shipping location from order's delivery address
      if (order.delivery_address_id) {
        setLocationId(order.delivery_address_id)
      }
    }
  }, [order, salesOrder, buyerId])

  useEffect(() => {
    if (salesOrder?.id) {
      setBuyerId(salesOrder?.buyer?.id)
      setSalesOrderNumber(salesOrder?.sales_order_number)
      setLocationId(salesOrder?.shipping_location_id || '')
      setShipVia(salesOrder?.ship_via || '')
      setPaymentTerms(salesOrder?.payment_terms || '')
      setFob(salesOrder?.fob || '')
      setSalesTax(salesOrder?.sales_tax || 0)
      setShippingCost(salesOrder?.shipping_cost || 0)
      let li = salesOrder?.sales_order_items?.map((lineItem) => {
        return {
          id: lineItem?.id,
          product_variant: lineItem?.product_variant,
          quantity: lineItem?.quantity,
          uom_id: lineItem?.uom?.id,
          price: lineItem?.price,
          oi_id: lineItem?.oi_id,
        }
      })
      setLineItems(li)
    }
  }, [salesOrder])

  const handleCancel = () => {
    setOpenAddSalesOrderModal(false)
    if (setUpdate) {
      setUpdate(false)
    }
    setError({})
    if (!buyer_id) setBuyerId()
    setArchiveLineItems([])
    setSalesOrder()
    setLineItems([])
    setLoading(false)
    setProductVariant()
    setSalesOrderNumber()
    setExpectedShipDate()
    setRequisitioner()
    setLocationId()
    setShipVia()
    setPaymentTerms()
    setFob()
    setSalesTax()
    setShippingCost()
  }

  const ValidateForm = () => {
    setError({})
    let Validate = true
    if (!salesOrderNumber || salesOrderNumber === '') {
      setError((prev) => {
        return { ...prev, sales_order_number: 'This field is required' }
      })
      Validate = false
    }
    if (!hideBusiness && !buyerId) {
      setError((prev) => {
        return { ...prev, buyer: 'This field is required' }
      })
      Validate = false
    }
    lineItems?.map((lineItem, index) => {
      if (!lineItem?.price || lineItem?.price <= 0) {
        setError((prev) => {
          return {
            ...prev,
            [index]: { ...prev[index], price: 'This field is required' },
          }
        })
        Validate = false
      }
      if (!lineItem?.buyer_unit_id) {
        setError((prev) => {
          return {
            ...prev,
            [index]: {
              ...prev[index],
              buyer_unit_id: 'This field is required',
            },
          }
        })
        Validate = false
      }
    })
    if (!lineItems || lineItems?.length === 0) {
      toast.error('Add line Items.')
      Validate = false
    }
    return Validate
  }

  const totalPrice = () => {
    return lineItems
      ?.map((lineItem) => {
        return lineItem?.price
          ? lineItem.price * (lineItem?.quantity ? lineItem.quantity : 0)
          : 0
      })
      .reduce(
        (accumulator, currentValue) =>
          parseFloat(accumulator) + parseFloat(currentValue),
        0
      )
  }

  async function createSalesOrder(sendToCustomer) {
    if (!ValidateForm()) {
      return
    }
    setLoading(true)
    let copyLineItems = lineItems?.map((lineItem) => {
      return {
        product_variant_id: lineItem?.product_variant?.id,
        quantity: parseFloat(lineItem?.quantity).toFixed(3),
        buyer_unit_id: lineItem?.buyer_unit_id,
        price: parseFloat(lineItem?.price).toFixed(3),
        oi_id: lineItem?.oi_id,
      }
    })
    let res = await axios.post('/main/admin-order-accounting-view/', {
      sales_order: true,
      order_id: order?.id,
      order_items: copyLineItems,
      sales_order_number: salesOrderNumber,
      send_email: sendToCustomer ? true : false,
      shipping_location_id: locationId,
      ship_via: shipVia,
      fob: fob,
      payment_terms: paymentTerms,
      expected_ship_date:
        expectedShipDate !== ''
          ? expectedShipDate.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })
          : '',
      requisitioner: requisitioner,
      order_number: salesOrderNumber,
      sales_tax: salesTax,
      shipping_cost: shippingCost,
    })

    if (res?.status < 300 && res?.data) {
      toast.success('Sales Order Added.')
      handleCancel()
      setReload(true)
    } else {
      if (res.error === 'buyer_contact') {
        toast.error('Please add a contact to the buyer.')
      } else {
        toast.error('Erorr adding sales order.')
      }
    }
    setLoading(false)
  }

  const getDiffrance = () => {
    let updatedItems = salesOrder?.sales_order_items?.map((lineItem) => {
      let updatedLineItem = lineItems?.find((li) => li.id === lineItem.id)
      if (updatedLineItem) {
        let updateli = {}
        if (lineItem?.quantity !== updatedLineItem?.quantity) {
          updateli = {
            ...updateli,
            quantity: parseFloat(updatedLineItem?.quantity).toFixed(3),
          }
        }
        if (lineItem?.uom?.id !== updatedLineItem?.uom_id) {
          updateli = { ...updateli, uom_id: updatedLineItem?.uom_id }
        }
        if (lineItem?.price !== updatedLineItem?.price) {
          updateli = {
            ...updateli,
            price: parseFloat(updatedLineItem?.price).toFixed(3),
          }
        }
        if (Object.keys(updateli).length) {
          return { ...updateli, id: lineItem?.id }
        }
      }
    })
    updatedItems = updatedItems?.filter((ui) => ui !== undefined)
    let newLineItems = []
    lineItems?.map((li) => {
      if (!li?.id) {
        newLineItems = [
          ...newLineItems,
          {
            product_variant_id: li?.product_variant?.id,
            quantity: li?.quantity,
            uom_id: li?.uom_id,
            price: li?.price,
          },
        ]
      }
    })
    let so = {}
    if (salesOrder?.sales_order_number !== salesOrderNumber) {
      so = { ...so, sales_order_number: salesOrderNumber }
    }
    if (!hideBusiness && salesOrder?.buyer?.id !== buyerId) {
      so = { ...so, buyer_id: buyerId }
    }
    if (salesOrder?.total_amount !== totalPrice()) {
      so = { ...so, total_amount: totalPrice().toFixed(2) }
    }
    let updatedData = {
      sales_order: so,
      delete_items_list: archiveLineItems,
      line_items_update: updatedItems,
      add_line_Items: newLineItems,
    }
    return updatedData
  }

  async function updateSalesOrder() {
    if (!ValidateForm()) {
      return
    }
    setLoading(true)
    let differentData = getDiffrance()
    let res = await axios.patch(`/main/admin-sales-order/${salesOrder?.id}/`, {
      ...differentData,
    })
    if (res && res?.status < 300) {
      toast.success('Sales order updated.')
      handleCancel()
      setReload(true)
    } else {
    }
    setLoading(false)
  }

  const handleLineItemChange = (index, field, value) => {
    let lineItemsCopy = [...lineItems]
    lineItemsCopy[index] = {
      ...lineItemsCopy[index],
      [field]: value,
    }
    setLineItems(lineItemsCopy)
  }

  const handleDropItemClick = (idx, id) => {
    setDropItemIdx(idx)
    if (update) setDropItemId(id)
    setOpenArchiveLineItemModal(true)
  }

  return (
    <>
      <Modal
        className="add-sales-order"
        size={'large'}
        open={openAddSalesOrderModal}
        onOpen={() => setOpenAddSalesOrderModal(true)}
        onClose={handleCancel}
      >
        <Modal.Header>
          <div>
            <span>{update ? 'Update' : 'Add'} Sales Order </span>
            <X size={20} weight="bold" onClick={handleCancel} />
          </div>
        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                <Form>
                  <Form.Group>
                    {/* SALES ORDER NUMBER */}
                    <Form.Field>
                      <label>
                        Sales Order Number{' '}
                        <span style={{ color: 'indianred' }}> *</span>
                      </label>
                      <Form.Input
                        placeholder={'Sales Order Number'}
                        name={'sales_order_number'}
                        type={'number'}
                        value={salesOrderNumber}
                        onChange={(e, d) => {
                          setSalesOrderNumber(d.value)
                        }}
                      />
                      {error && error?.sales_order_number && (
                        <p style={{ color: 'red' }}>
                          <small>{error?.sales_order_number}</small>
                        </p>
                      )}
                    </Form.Field>
                    {/* BUYER */}
                    {!hideBusiness && (
                      <Form.Field width={4}>
                        <label>
                          Buyer <span style={{ color: 'indianred' }}> *</span>
                        </label>
                        <MickeyDropdown
                          placeholder={'Buyer'}
                          url={'/main/buyers/'}
                          name={'buyer'}
                          value={buyerId}
                          defaultValue={salesOrder?.buyer?.id}
                          params={{
                            page_size: 'infinite',
                          }}
                          tenantAware={false}
                          titleFields={['business.name']}
                          descriptionFields={[]}
                          onChange={(e, d) => setBuyerId(d.value)}
                        />
                        {error && error?.buyer && (
                          <p style={{ color: 'red' }}>
                            <small>{error?.buyer}</small>
                          </p>
                        )}
                      </Form.Field>
                    )}
                    {/* SHIPPING LOCATION */}
                    <Form.Field>
                      <label>
                        Shipping Location{' '}
                        <span style={{ color: 'indianred' }}> *</span>
                      </label>
                      <MickeyDropdown
                        placeholder={'Shipping Location'}
                        url={'/main/admin-locations/'}
                        name={'location'}
                        value={locationId}
                        params={{
                          buyer_id: buyerId || buyer?.id || order?.buyer?.id,
                          sales_order_id: salesOrder?.id,
                          page_size: 25,
                          admin_cargo_unit_instance_id: true,
                        }}
                        tenantAware={false}
                        titleFields={['name']}
                        descriptionFields={[
                          'address_1',
                          'city',
                          'state',
                          'zip_code',
                        ]}
                        onChange={(e, d) => setLocationId(d.value)}
                      />
                    </Form.Field>
                    {/* SHIP VIA */}
                    <Form.Field>
                      <label>Ship Via</label>
                      <Form.Input
                        placeholder={'Ship Via'}
                        name={'ship_via'}
                        value={shipVia}
                        onChange={(e, d) => setShipVia(d.value)}
                      />
                    </Form.Field>
                    {/* EXPECTED SHIP DATE */}
                    <Form.Field>
                      <label>Expected Ship Date</label>
                      <div className="customDatePickerWidth auto-datepicker">
                        <SemanticDatepicker
                          value={expectedShipDate}
                          onChange={(e, d) => setExpectedShipDate(d.value)}
                          format="MMM D,YYYY"
                        />
                      </div>
                    </Form.Field>

                    {/* <Form.Field>
                      <Button
                        content={'Add Line Item'}
                        color="primary"
                        icon={
                          <Plus
                            size={20}
                            weight="bold"
                            style={{ marginRight: '5px' }}
                          />
                        }
                        style={{
                          '--primaryColor': tenant?.deployment_primary_color,
                          '--secondaryColor':
                            tenant?.deployment_secondary_color,
                        }}
                        onClick={() => setOpenProductVariantModal(true)}
                      />
                    </Form.Field> */}
                  </Form.Group>
                  <Form.Group>
                    {/* REQUISITIONER */}
                    <Form.Field>
                      <label>Requisitioner</label>
                      <Form.Input
                        placeholder={'Requisitioner'}
                        name={'requisitioner'}
                        value={requisitioner}
                        onChange={(e, d) => setRequisitioner(d.value)}
                      />
                    </Form.Field>
                    {/* PAYMENT TERMS */}
                    <Form.Field>
                      <label>Payment Terms</label>
                      <Form.Input
                        placeholder={'Payment Terms'}
                        name={'payment_terms'}
                        value={paymentTerms}
                        onChange={(e, d) => setPaymentTerms(d.value)}
                      />
                    </Form.Field>
                    {/* FOB */}
                    <Form.Field>
                      <label>FOB</label>
                      <Form.Input
                        placeholder={'FOB'}
                        name={'fob'}
                        value={fob}
                        onChange={(e, d) => setFob(d.value)}
                      />
                    </Form.Field>

                    {/* <Form.Field>
                      <Button
                        content={'Add Line Item'}
                        color="primary"
                        icon={
                          <Plus
                            size={20}
                            weight="bold"
                            style={{ marginRight: '5px' }}
                          />
                        }
                        style={{
                          '--primaryColor': tenant?.deployment_primary_color,
                          '--secondaryColor':
                            tenant?.deployment_secondary_color,
                        }}
                        onClick={() => setOpenProductVariantModal(true)}
                      />
                    </Form.Field> */}
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <MickeyTable
            headerRow={[
              'Product',
              'Quantity',
              'Unit of Measure',
              'Price',
              'Total Price',
              'Actions',
            ]}
            basicSegment
            showHeaderNoData={true}
            data={lineItems}
            renderBodyRow={(lineItem, index) => {
              return (
                <Table.Row>
                  <Table.Cell width={5}>
                    <OrderItemDetailTwo orderItem={lineItem} />
                  </Table.Cell>
                  <Table.Cell>
                    <Input
                      placeholder={'Quantity'}
                      type={'number'}
                      step={0.01}
                      min={0}
                      value={lineItem?.quantity}
                      defaultValue={lineItem?.quantity}
                      style={{ maxWidth: '150px' }}
                      onChange={(e, d) => {
                        if (d.value >= 0) {
                          handleLineItemChange(index, 'quantity', d.value)
                        }
                      }}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <MickeyDropdown
                      url={'/main/unit-of-measures/'}
                      name={'unit_of_measure'}
                      value={lineItem?.buyer_unit_id}
                      defaultValue={lineItem?.buyer_unit_id}
                      params={{
                        page_size: 'infinite',
                        product_id: lineItem?.product_variant?.product_id,
                      }}
                      autoComplete="new-password"
                      placeholder={'Select UOM'}
                      titleFields={['plural_name']}
                      descriptionFields={[]}
                      onChange={(e, d) => {
                        handleLineItemChange(index, 'uom_id', d.value)
                      }}
                    />
                    {error && error[index]?.uom_id && (
                      <p style={{ color: 'red' }}>
                        <small>{error[index]?.uom_id}</small>
                      </p>
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    <Input
                      placeholder={'Price'}
                      type={'number'}
                      step={0.01}
                      min={0}
                      value={lineItem?.price}
                      defaultValue={lineItem?.price}
                      style={{ maxWidth: '150px' }}
                      onChange={(e, d) => {
                        if (d.value >= 0) {
                          handleLineItemChange(index, 'price', d.value)
                        }
                      }}
                    />
                    {error && error[index]?.price && (
                      <p style={{ color: 'red' }}>
                        <small>{error[index]?.price}</small>
                      </p>
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {formatTotalPrice(
                      lineItem?.price
                        ? lineItem.price *
                            (lineItem?.quantity ? lineItem?.quantity : 0)
                        : 0
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    <Button
                      color="red"
                      icon={
                        <TrashSimple
                          size={20}
                          weight="bold"
                          style={{ marginRight: '5px' }}
                        />
                      }
                      content={'Delete'}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      onClick={() => handleDropItemClick(index, lineItem?.id)}
                    />
                  </Table.Cell>
                </Table.Row>
              )
            }}
            footerRow={
              <>
                <Table.Row>
                  <Table.HeaderCell>
                    <b>Shipping Cost</b>
                  </Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell colSpan="2">
                    <b>
                      <Form.Field width={4}>
                        <Form.Input
                          placeholder={'Shipping'}
                          value={shippingCost}
                          onChange={(e, d) => {
                            setShippingCost(d.value)
                          }}
                        />
                      </Form.Field>
                    </b>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell>
                    <b>Sales Tax</b>
                  </Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell colSpan="2">
                    <b>
                      <Form.Field width={4}>
                        <Form.Input
                          placeholder={'Sales Tax'}
                          value={salesTax}
                          onChange={(e, d) => {
                            setSalesTax(d.value)
                          }}
                        />
                      </Form.Field>
                    </b>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell colSpan="4" />
                  <Table.HeaderCell colSpan="2">
                    <b>{formatTotalPrice(totalPrice())}</b>
                  </Table.HeaderCell>
                </Table.Row>
              </>
            }
            emptyIcon={'file'}
            emptyMessage={'Line items will populate here'}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={handleCancel}
            color={'gray'}
            style={{
              width: '8.5em',
              marginRight: '2em',
            }}
            content={'Cancel'}
          />
          <Button
            type="submit"
            loading={loading}
            disabled={!salesOrderNumber || !buyerId || !lineItems?.length}
            onClick={() => {
              if (update) {
                updateSalesOrder(false)
              } else {
                createSalesOrder(false)
              }
            }}
            color="primary"
            style={{
              width: '16.5em',
              '--primaryColor': tenant?.deployment_primary_color,
              '--secondaryColor': tenant?.deployment_secondary_color,
            }}
            content={update ? 'Update' : 'Create'}
          />
          <Button
            type="submit"
            loading={loading}
            disabled={!salesOrderNumber || !buyerId || !lineItems?.length}
            onClick={() => {
              if (update) {
                updateSalesOrder(true)
              } else {
                createSalesOrder(true)
              }
            }}
            color="primary"
            style={{
              width: '16.5em',
              '--primaryColor': tenant?.deployment_primary_color,
              '--secondaryColor': tenant?.deployment_secondary_color,
            }}
            content={
              update
                ? 'Update and Send to Customer'
                : 'Create and Send to Customer'
            }
          />
        </Modal.Actions>
      </Modal>
      <GetProductVariant
        productVariant={productVariant}
        setProductVariant={setProductVariant}
        openProductVariantModal={openProductVariantModal}
        setOpenProductVariantModal={setOpenProductVariantModal}
      />
      <ConfirmationModal
        message={'Are you sure you want to archive this line item?'}
        confirmationModal={openArchiveLineItemModal}
        setConfirmationModal={setOpenArchiveLineItemModal}
        yesFunction={() => {
          if (update) {
            setArchiveLineItems([...archiveLineItems, dropItemId])
          }
          let li = [...lineItems]
          li.splice(dropItemIdx, 1)
          setLineItems(li)
          setOpenArchiveLineItemModal(false)
          setDropItemId()
          setDropItemIdx()
        }}
        noFunction={() => {
          setDropItemId()
          setDropItemIdx()
          setOpenArchiveLineItemModal(false)
        }}
      />
    </>
  )
}

export default AddSalesOrder
